export { OptexHomepageBiaGuest } from './optex-homepage-bia-guest';
